import { useCallback, useState } from 'react'
import { NotificationInboxStateFilter } from '@src/types'
import { useDispatchAsync, useSnack } from '@src/utils'

interface UseMarkAllInboxNotificationsReadParams {
  unreadCount: number
  stateFilter: NotificationInboxStateFilter
}

export const useMarkAllInboxNotificationsRead = ({
  unreadCount,
  stateFilter,
}: UseMarkAllInboxNotificationsReadParams) => {
  const dispatchAsync = useDispatchAsync()
  const showSnack = useSnack()
  const [markAllAsReadLoading, setMarkAllAsReadLoading] = useState(false)

  const handleMarkAllAsRead = useCallback(async () => {
    if (markAllAsReadLoading || unreadCount === 0) {
      return
    }

    setMarkAllAsReadLoading(true)

    try {
      await dispatchAsync({
        type: 'notifications/markAllRead',
      })

      const [fetchLiveResult, fetchInboxResult] = await Promise.allSettled([
        dispatchAsync({ type: 'notifications/fetchLive' }),
        dispatchAsync({
          type: 'notifications/fetchInbox',
          payload: { stateFilter },
        }),
      ])

      if (fetchLiveResult.status === 'rejected') {
        throw fetchLiveResult.reason
      }

      if (fetchInboxResult.status === 'rejected') {
        throw fetchInboxResult.reason
      }
    } catch (error: any) {
      showSnack(error?.message || 'Failed to mark as read.', null, 'error')
    } finally {
      setMarkAllAsReadLoading(false)
    }
  }, [dispatchAsync, markAllAsReadLoading, showSnack, stateFilter, unreadCount])

  return {
    markAllAsReadLoading,
    onMarkAllAsReadPress: handleMarkAllAsRead,
  }
}
